// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PanelCheckbox_wrapper__jXvWp","wrapperChecked":"PanelCheckbox_wrapperChecked__nSuks"};